export const getWidthForAnimation = () => {
  const windowWidth = window.innerWidth;

  const desktopContainerWidth = 1024;
  const mobileContainerWidth = 769;

  let containerWidth;

  if (windowWidth >= desktopContainerWidth) {
    containerWidth = desktopContainerWidth;
  } else if (windowWidth >= mobileContainerWidth) {
    containerWidth = mobileContainerWidth;
  } else {
    containerWidth = windowWidth;
  }

  const widthForAnimation = (windowWidth - containerWidth) / 2;

  return widthForAnimation;
};
